// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"reactionFeed_placeholder__1_2fA"};